import ApiService from './ApiService';

export default class SyncApi extends ApiService {
    createUserByEmail() {
        return this.post('create-ei-std');
    }

    checkUserByEmail(payload) {
        return this.get('check-ei-user', payload);
    }

    getStdEiInfo(payload) {
        return this.get('get-std-ei-info', payload);
    }

    syncAndCreateWithEi(payload) {
        return this.post('sync-and-create-with-ei', payload);
    }

}
